import { useState, useEffect } from 'react'

export function useFilters() {
    const initialState = JSON.parse(localStorage.getItem('user_filters')) || {}

    // Создаем управляемое состояние для хранения текущих фильтров
    const [filters, setFilters] = useState<any>(initialState)

    // Сохраняем значение фильтров при изменении состояния
    useEffect(() => {
        localStorage.setItem('user_filters', JSON.stringify(filters))
    }, [filters])

    return [filters, setFilters]
}